import { render, staticRenderFns } from "./TrainingItemFeedbackResult.vue?vue&type=template&id=6b9f6c26&"
import script from "./TrainingItemFeedbackResult.vue?vue&type=script&lang=js&"
export * from "./TrainingItemFeedbackResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports